import moment from 'moment';

export default function dateFriendly(timestamp) {
  return moment(timestamp).format('ddd MMM D, YYYY');
}
